import React from "react";

/** Premium hand-crafted SVG diya with animated flame & glow. */
export default function Diya({ className = "", size = 64 }) {
  const id = React.useId();
  return (
    <svg width={size} height={size * 0.9} viewBox="0 0 120 108" fill="none" className={className} aria-hidden="true">
      <defs>
        <radialGradient id={`${id}-glow`} cx="50%" cy="42%" r="55%">
          <stop offset="0%" stopColor="#FFC94D" stopOpacity="0.85" />
          <stop offset="45%" stopColor="#F59E0B" stopOpacity="0.28" />
          <stop offset="100%" stopColor="#F59E0B" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={`${id}-flame`} x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#E67300" />
          <stop offset="55%" stopColor="#FFB300" />
          <stop offset="100%" stopColor="#FFF3C4" />
        </linearGradient>
        <linearGradient id={`${id}-bowl`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#A8500F" />
          <stop offset="45%" stopColor="#7A3408" />
          <stop offset="100%" stopColor="#4A1E04" />
        </linearGradient>
        <linearGradient id={`${id}-rim`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#D4AF37" />
          <stop offset="50%" stopColor="#F6E27A" />
          <stop offset="100%" stopColor="#D4AF37" />
        </linearGradient>
      </defs>

      <circle cx="60" cy="44" r="52" fill={`url(#${id}-glow)`} className="diya-glow-anim" />

      {/* flame */}
      <g className="diya-flame" style={{ transformOrigin: "60px 62px" }}>
        <path d="M60 18 C 68 34, 74 42, 74 52 A 14 14 0 0 1 46 52 C 46 42, 52 34, 60 18 Z" fill={`url(#${id}-flame)`} />
        <ellipse cx="60" cy="52" rx="5.5" ry="8" fill="#FFF7D6" opacity="0.9" />
      </g>
      {/* wick */}
      <rect x="58.6" y="56" width="2.8" height="8" rx="1.4" fill="#3A1A05" />

      {/* bowl */}
      <path d="M14 64 Q 60 56 106 64 L 100 82 Q 60 100 20 82 Z" fill={`url(#${id}-bowl)`} />
      <path d="M14 64 Q 60 56 106 64 Q 60 74 14 64 Z" fill={`url(#${id}-rim)`} />
      <path d="M26 74 Q 60 84 94 74" stroke="#F6E27A" strokeWidth="2.2" fill="none" opacity="0.75" strokeLinecap="round" />
      <path d="M32 80 Q 60 88 88 80" stroke="#D4AF37" strokeWidth="1.6" fill="none" opacity="0.5" strokeLinecap="round" />
    </svg>
  );
}
